import { Component, OnDestroy, OnInit } from '@angular/core';

import { EventEmitterService } from '../../base/util/event-emitter.service';
import { BuscarGtoService } from './buscar-gto/buscar-gto.service';


@Component({
  selector: 'app-gto-dashboard',
  templateUrl: './gto-dashboard.component.html',
  styleUrls: ['./gto-dashboard.component.css']
})
export class GtoDashboardComponent implements OnInit, OnDestroy {

  public btnMenu;
  badgesSubscription: any;
  pendentes = 0;
  id
  isLoading = false;


  constructor(public buscarGtoService: BuscarGtoService, public eventEmitterService: EventEmitterService) {

    // setInterval(() => { this.buscarGtoService.countPendentes().subscribe(
    //   data => {
    //     this.pendentes = data.data;
    //   },
    //   error => {
    //     console.log("Count pendentes false");
    //   });; }, 1000 * 60 * 1);

  }

  ngOnInit() {
    this.btnMenu = 1;

    let efetuarBuscaGto = JSON.parse(localStorage.getItem("efetuar-busca-gto"));
    let gtoFiltroTmp = JSON.parse(localStorage.getItem("filtro-busca-gto"));
    if (efetuarBuscaGto && gtoFiltroTmp != null) {
      this.btnMenu = gtoFiltroTmp.tipoBusca;
    }

    this.buscarGtoService.countPendentes().subscribe(
      data => {
        this.pendentes = data.data;
      },
      error => {
        console.log("Count pendentes false");
      });

    /*
      this.badgesSubscription = this.eventEmitterService.getBadgesEmittedValue()
          .subscribe(item => this.pendentes=item);

      this.id = setInterval(() => { this.buscarGtoService.countPendentes().subscribe(
        data => {
          this.pendentes = data.data;
        },
        error => {
          console.log("Count pendentes false");
        });; }, 1000 * 60 * 1);
        */
  }

  selectedMenu(menu) {
    this.btnMenu = menu;
  }

  selectedButton() {
    return this.btnMenu;
  }

  ngOnDestroy() {
    /*
      this.badgesSubscription.unsubscribe();
      if (this.id) {
        clearInterval(this.id);
      }
      */
  }

  setLoading(event: boolean) {
    this.isLoading = event
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/gto-dashboard/gto-dashboard.component.ts